import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Button Component
 * Based on shadcn/ui Button with DckSlap dark red theme
 */
const buttonVariants = {
    variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-border bg-transparent hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        success: "bg-success text-success-foreground hover:bg-success/90",
    },
    size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        xl: "h-12 rounded-lg px-10 text-base",
        icon: "h-10 w-10",
    },
};

const Button = React.forwardRef(
    ({ className, variant = "default", size = "default", asChild = false, ...props }, ref) => {
        const Comp = asChild ? React.Fragment : "button";

        const variantClasses = buttonVariants.variant[variant] || buttonVariants.variant.default;
        const sizeClasses = buttonVariants.size[size] || buttonVariants.size.default;

        return (
            <Comp
                className={cn(
                    // Base styles
                    "inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium",
                    // Transitions
                    "transition-colors duration-200",
                    // Focus styles
                    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
                    // Disabled styles
                    "disabled:pointer-events-none disabled:opacity-50",
                    // Variant and size
                    variantClasses,
                    sizeClasses,
                    className
                )}
                ref={ref}
                {...props}
            />
        );
    }
);
Button.displayName = "Button";

export { Button, buttonVariants };
